import styles from "./styles.module.css";
import { useContext, useState } from "react";
import { BlocksValue } from "../../../contexts/blocks";
import { AppValue } from "../../../contexts/app";
import Results from "./results";
import Card from "./card";
import CompCard from "./compcard";
import Search from "./search";
import { useParams } from "react-router-dom";
export default function Blocks({ open }) {
  const blocks = useContext(BlocksValue);
  const { components } = useContext(AppValue);
  const { pageId } = useParams();
  const [search, setSearch] = useState("");
  return (
    <div
      style={{
        overflowY: "scroll",
        boxSizing: "border-box",
        boxSizing: "border-box",
        position: "absolute",
        top: 80,
        left: 10,
        right: 10,
        paddingBottom: 60,
      }}
      className={open ? styles.open : styles.close}
    >
      <Search value={search} onChange={setSearch} />
      {!!search ? (
        <Results pageId={pageId} search={search} />
      ) : (
        <>
          <h4 style={{ margin: "15px 0px 0px 0px" }}>Basic</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {blocks
              .filter((x) => x.type === "basic")
              .filter((x) => {
                return x.name.includes(search) || !search;
              })
              .map((b) => {
                return <Card block={b} key={b.name} />;
              })}
          </div>
          <h4 style={{ margin: "15px 0px 0px 0px" }}>Containers</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {blocks
              .filter((x) => x.type === "container")
              .filter((x) => {
                return x.name.includes(search) || !search;
              })
              .map((b) => {
                return <Card block={b} key={b.name} />;
              })}
          </div>
          <h4 style={{ margin: "15px 0px 0px 0px" }}>Inputs</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {blocks
              .filter((x) => x.type === "input")
              .filter((x) => {
                return x.name.includes(search) || !search;
              })
              .map((b) => {
                return <Card block={b} type={null} key={b.name} />;
              })}
          </div>
          <h4 style={{ margin: "15px 0px 0px 0px" }}>Overlays</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {blocks
              .filter((x) => x.type === "overlay")
              .filter((x) => {
                return x.name.includes(search) || !search;
              })
              .map((b) => {
                return <Card block={b} type="overlay" key={b.name} />;
              })}
          </div>
          <h4 style={{ margin: "15px 0px 0px 0px" }}>Components</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {components
              .filter((x) => x.id !== pageId)
              .filter((x) => {
                return x.name.includes(search) || !search;
              })
              .map((b) => {
                return <CompCard key={b.name} comp={b} />;
              })}
          </div>
        </>
      )}
    </div>
  );
}
